import { createExportLocale } from "../export-locale";

export default createExportLocale({
  action: "Export",
  markdown: "Markdown report",
  csv: "Spreadsheet CSV",
  printSavePdf: "Print / Save as PDF",
  completed: "Report export is ready.",
  failed: "The report could not be exported.",
  context: "Scope and basis",
  generatedAt: "Generated {generatedAt}",
  asOf: "As of",
  period: "For the period",
  accountFilter: "Account filter",
  advancedFilter: "Advanced filter",
  interval: "Interval",
  conversion: "Conversion",
  notApplied: "Not applied",
  currency: "Currency",
  unit: "Unit",
  amount: "Amount",
  unauditedManagementReport: "Unaudited management report",
  unauditedMultiUnitManagementReport:
    "Unaudited multi-unit management schedule",
  unauditedInternalDraft: "Unaudited internal draft",
  statementSummary: "Statement summary",
  lineItem: "Line item",
  totalAssets: "Total Assets",
  totalLiabilities: "Total Liabilities",
  totalEquity: "Total Equity",
  totalLiabilitiesAndEquity: "Total Liabilities and Equity",
  reconciliationDifference: "Reconciliation Difference",
  totalRevenue: "Total Revenue and Other Income",
  totalExpenses: "Total Expenses",
  netLoss: "Net Loss",
  netCashOperating: "Net Cash from Operating Activities",
  netCashInvesting: "Net Cash from Investing Activities",
  netCashFinancing: "Net Cash from Financing Activities",
  netChangeInCash: "Net Change in Cash & Equivalents",
  openingCash: "Cash & Equivalents at Period Start",
  closingCash: "Cash & Equivalents at Period End",
  supportingAccountDetail: "Supporting Account Detail",
  allActivity: "All available ledger activity through",
  dateUnavailable: "Reporting date unavailable",
  presentationCurrency: "Presentation currency",
  ledgerUnits: "Ledger units shown",
  sourceLedger: "Source ledger",
  importantNotices: "Important notices",
  reportingEntity: "Reporting entity",
  netIncome: "Net Income",
  reportingEntityFallbackNotice:
    'No reporting entity is configured. The source ledger name is used; set Beancount option "title" before external use.',
  placeholderDataNotice:
    "The reporting entity or source ledger appears to contain example data. Replace it before external use.",
  inferredPeriodNotice:
    "This report covers ledger activity from {startDate} through {endDate}. The dates were derived from the available report data.",
  periodNotExplicitNotice:
    "A complete reporting period could not be determined. This statement remains an internal draft.",
  inferredAsOfDateNotice:
    "No explicit as-of date was selected. This statement includes all ledger activity through {asOfDate}.",
  asOfDateUnavailableNotice:
    "An as-of date could not be determined. This statement remains an internal draft.",
  subtotalRowsNotice:
    "Bold rows are subtotals or totals and should not be added to their underlying detail rows.",
  partialReportNotice:
    "Account or advanced filters limit this statement; it is not a complete financial statement.",
  balanceSheetClassificationNotice:
    "Current and non-current classifications are not available from the source ledger; accounts are presented in ledger order.",
  balanceSheetDoesNotReconcileNotice:
    "The accounting equation does not reconcile for one or more units. Review unclosed earnings, partial filters, valuation or conversion effects, and ledger errors before external use. This statement remains an internal draft.",
  cashFlowClassificationNotice:
    "Operating, investing, and financing activities are inferred from account types and names for accounts without a declared cash-flow-role; accounts that declare one are classified as written.",
  cashFlowCashEquivalentsNotice:
    "The cash and cash equivalents set is inferred from account names (checking, savings, and cash-style asset accounts). Review the included accounts before external use.",
  customUnitsNotice: "Custom ledger units requiring review:",
  customUnitsDefinitionNotice:
    "Their meanings are not available in this export; document them in an accompanying note before external use.",
  multiUnitScheduleNotice:
    "This multi-unit report is a management schedule, not a single-currency financial statement. Do not add amounts across units; select a presentation currency before external use.",
  noAssurance:
    "No assurance is provided. Prepared from user-supplied ledger records; entity identity, completeness, valuation, and accounting-framework compliance are not verified.",
  generatedBy: "Generated by Beancount.io on {generatedAt}",
});
